/* ==========================================================================
   nav-featured.js — The Park Wholesale
   Mobile menu, Brands panel: A–Z letter strip jumps to that letter's group.
   Markup: snippets/mobile-menu-panel.liquid (.mm-az__jump[data-mm-jump]).
   Loaded deferred from sections/header.liquid. Vanilla JS, no dependencies.
   ========================================================================== */
(function () {
  if (window.__navFeaturedInit) return;
  window.__navFeaturedInit = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-mm-jump]');
    if (!button) return;

    var group = document.getElementById(button.getAttribute('data-mm-jump'));
    if (!group) return;

    event.preventDefault();

    // Scroll the drawer panel to the letter group (sticky strip offset handled by scroll-margin-top in CSS)
    group.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'auto' : 'smooth' });

    // Move focus to the letter heading so keyboard / screen-reader users continue from there
    var heading = group.querySelector('.mm-az__letter');
    if (heading) heading.focus({ preventScroll: true });

    // Mark the active letter and keep it visible in the strip
    var strip = button.parentElement;
    var current = strip.querySelectorAll('[aria-current]');
    for (var i = 0; i < current.length; i++) current[i].removeAttribute('aria-current');
    button.setAttribute('aria-current', 'true');
    // (scroll the strip itself, not scrollIntoView, so the vertical jump above is not interrupted)
    strip.scrollTo({
      left: button.offsetLeft - (strip.clientWidth - button.offsetWidth) / 2,
      behavior: reduceMotion ? 'auto' : 'smooth'
    });
  });
})();

/* ==========================================================================
   Brands search — desktop dropdown (snippets/site-nav.liquid) and mobile Brands panel
   (snippets/mobile-menu-panel.liquid); the box: snippets/brand-search-box.liquid.
   Typing narrows the A–Z list itself (name starts with it > a later word starts with it >
   contains, contains only from 2 letters); the matching part is highlighted, empty letter groups
   and their letters are hidden. Nothing else appears under the box — only "Show all brands" when
   nothing matches. Screen readers hear "N brands found" (visually hidden live region).
   Keyboard: Enter opens the brand when only one is left or its exact name is typed; Esc clears
   (a second Esc closes the menu as before).
   Phones (mobile Brands panel) — "search mode": tapping the box pins it to the top of the panel
   with the list right under it (featured tiles, title and letter strip step aside). Scrolling the
   list closes the keyboard but the box stays pinned. Only the × leaves search mode: it clears the
   text, closes the keyboard and puts the panel back as it was.
   ========================================================================== */
(function () {
  if (window.__brandSearchInit) return;
  window.__brandSearchInit = true;

  var SPLIT = /[\s\-+.&/]+/;

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  // 0 = name starts with it · 1 = a later word starts with it · 2 = contains (2+ letters) · -1 = no
  function score(lower, t) {
    if (lower.indexOf(t) === 0) return 0;
    var words = lower.split(SPLIT);
    for (var i = 1; i < words.length; i++) if (words[i].indexOf(t) === 0) return 1;
    if (t.length > 1 && lower.indexOf(t) > -1) return 2;
    return -1;
  }
  function highlight(name, t) {
    var lower = name.toLowerCase();
    var at = -1;
    if (lower.indexOf(t) === 0) at = 0;
    else {
      var re = new RegExp('(^|[\\s\\-+.&/])' + t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
      var m = re.exec(lower);
      at = m ? m.index + m[1].length : lower.indexOf(t);
    }
    if (at < 0) return esc(name);
    return esc(name.slice(0, at)) + '<mark>' + esc(name.slice(at, at + t.length)) + '</mark>' + esc(name.slice(at + t.length));
  }

  function setup(root) {
    if (root.__bs) return;
    root.__bs = true;
    var input = root.querySelector('[data-bs-input]');
    if (!input) return;

    var hint = root.querySelector('[data-bs-hint]');
    var empty = root.querySelector('[data-bs-empty]');
    var qText = root.querySelector('[data-bs-qtext]');
    var xBtn = root.querySelector('.bs-search [data-bs-clear]');
    var panelBody = root.closest('.mm-panel__body');
    var groups = [].slice.call(root.querySelectorAll('[data-bs-group]'));
    var jumps = [].slice.call(root.querySelectorAll('[data-mm-jump]'));
    var items = [].slice.call(root.querySelectorAll('[data-bs-item]')).map(function (li) {
      var el = li.querySelector('[data-bs-name]');
      var name = el ? el.getAttribute('data-bs-name') : '';
      return { li: li, el: el, name: name, lower: name.toLowerCase(), nameEl: li.querySelector('.bs__name'), s: 0 };
    }).filter(function (d) { return d.el; });
    var label = (input.getAttribute('placeholder') || 'Search brands').replace(/^Search\s+/i, '') || 'brands';
    var results = [];
    var timer;

    function apply() {
      var raw = input.value.trim();
      var t = raw.toLowerCase();
      if (xBtn) xBtn.hidden = !raw && !root.classList.contains('is-search-mode');
      root.classList.toggle('is-searching', !!t);
      if (panelBody) panelBody.classList.toggle('is-searching', !!t);

      results = [];
      items.forEach(function (d) {
        d.s = t ? score(d.lower, t) : 0;
        var show = d.s > -1;
        d.li.hidden = !show;
        if (d.nameEl) d.nameEl.innerHTML = t && show ? highlight(d.name, t) : esc(d.name);
        if (show && t) results.push(d);
      });
      groups.forEach(function (g) { g.hidden = !g.querySelector('[data-bs-item]:not([hidden])'); });
      jumps.forEach(function (b) {
        var g = document.getElementById(b.getAttribute('data-mm-jump'));
        b.hidden = !!(g && g.hidden);
      });

      empty.hidden = !(t && !results.length);
      if (!empty.hidden) qText.textContent = raw;

      // screen readers: say how many were found, after typing pauses
      clearTimeout(timer);
      timer = setTimeout(function () {
        hint.textContent = !t ? '' : results.length ? results.length + ' ' + (results.length === 1 ? label.replace(/s$/, '') : label) + ' found' : '';
      }, 400);
    }

    function single() {
      var t = input.value.trim().toLowerCase();
      if (t.length < 2 || !results.length) return null;
      var exact = results.filter(function (d) { return d.lower === t; })[0];
      return exact || (results.length === 1 ? results[0] : null);
    }

    input.addEventListener('input', apply);

    // ---- phones: search mode (mobile Brands panel only) ----
    var phone = window.matchMedia('(max-width: 749px)');
    var wrap = root.querySelector('.mm-az__search');
    function scroller(el) {
      for (var p = el.parentElement; p; p = p.parentElement) {
        var oy = window.getComputedStyle(p).overflowY;
        if ((oy === 'auto' || oy === 'scroll') && p.scrollHeight > p.clientHeight) return p;
      }
      return null;
    }
    function enterSearch() {
      if (!wrap || !phone.matches || root.classList.contains('is-search-mode')) return;
      root.classList.add('is-search-mode');
      if (panelBody) panelBody.classList.add('is-search-mode');
      if (xBtn) xBtn.hidden = false;
      var sc = scroller(wrap);
      if (sc) sc.scrollTop += wrap.getBoundingClientRect().top - sc.getBoundingClientRect().top;
    }
    function leaveSearch() {
      root.classList.remove('is-search-mode');
      if (panelBody) panelBody.classList.remove('is-search-mode');
      input.value = '';
      apply();
      input.blur();
      var sc = scroller(root);
      if (sc) sc.scrollTop = 0;
    }
    if (wrap) {
      input.addEventListener('focus', enterSearch);
      // scrolling the list closes the keyboard; the box stays pinned
      root.addEventListener('touchmove', function (e) {
        if (phone.matches && document.activeElement === input && !wrap.contains(e.target)) input.blur();
      }, { passive: true });
    }

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var d = single();
        if (d) {
          if (d.el.tagName === 'A') window.location.href = d.el.href;
          else d.el.click(); // brand with its own sub-menu (mobile): open its panel
        } else input.blur(); // several left: just close the phone keyboard
      } else if (e.key === 'Escape' && (input.value || root.classList.contains('is-search-mode'))) {
        e.preventDefault(); e.stopPropagation(); // clear first; the next Esc closes the menu as before
        if (root.classList.contains('is-search-mode')) leaveSearch();
        else { input.value = ''; apply(); }
      }
    });
    root.querySelectorAll('[data-bs-clear]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b === xBtn && root.classList.contains('is-search-mode')) { leaveSearch(); return; }
        input.value = ''; apply(); input.focus();
      });
    });
  }

  function init() { document.querySelectorAll('[data-brand-search]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();